import * as React from 'react';
import CaretDownFilled from '@ant-design/icons/CaretDownFilled';
import FileOutlined from '@ant-design/icons/FileOutlined';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import MinusSquareOutlined from '@ant-design/icons/MinusSquareOutlined';
import PlusSquareOutlined from '@ant-design/icons/PlusSquareOutlined';
import { clsx } from 'clsx';
import { cloneElement } from '../../_util/reactNode';
const SwitcherIconCom = (props) => {
    const { prefixCls, switcherIcon, treeNodeProps, showLine, switcherLoadingIcon } = props;
    const { isLeaf, expanded, loading } = treeNodeProps;
    if (loading) {
        if (React.isValidElement(switcherLoadingIcon)) {
            return switcherLoadingIcon;
        }
        return React.createElement(LoadingOutlined, { className: `${prefixCls}-switcher-loading-icon` });
    }
    let showLeafIcon;
    if (showLine && typeof showLine === 'object') {
        showLeafIcon = showLine.showLeafIcon;
    }
    if (isLeaf) {
        if (!showLine) {
            return null;
        }
        if (typeof showLeafIcon !== 'boolean' && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === 'function' ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (React.isValidElement(leafIcon)) {
                return cloneElement(leafIcon, {
                    className: clsx(leafIcon.props?.className, leafCls),
                });
            }
            return leafIcon;
        }
        return showLeafIcon ? (React.createElement(FileOutlined, { className: `${prefixCls}-switcher-line-icon` })) : (React.createElement("span", { className: `${prefixCls}-switcher-leaf-line` }));
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(treeNodeProps) : switcherIcon;
    if (React.isValidElement(switcher)) {
        return cloneElement(switcher, {
            className: clsx(switcher.props?.className, switcherCls),
        });
    }
    if (switcher !== undefined) {
        return switcher;
    }
    if (showLine) {
        return expanded ? (React.createElement(MinusSquareOutlined, { className: `${prefixCls}-switcher-line-icon` })) : (React.createElement(PlusSquareOutlined, { className: `${prefixCls}-switcher-line-icon` }));
    }
    return React.createElement(CaretDownFilled, { className: switcherCls });
};
export default SwitcherIconCom;
